import { render, staticRenderFns } from "./ViewCompany.vue?vue&type=template&id=08b12ae8&scoped=true&"
import script from "./ViewCompany.vue?vue&type=script&lang=js&"
export * from "./ViewCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b12ae8",
  null
  
)

export default component.exports